import { render, staticRenderFns } from "./CollaboratorsListModal.vue?vue&type=template&id=b666eb90&scoped=true"
import script from "./CollaboratorsListModal.vue?vue&type=script&lang=ts"
export * from "./CollaboratorsListModal.vue?vue&type=script&lang=ts"
import style0 from "./CollaboratorsListModal.vue?vue&type=style&index=0&id=b666eb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b666eb90",
  null
  
)

export default component.exports